/**
 * Country/state/city using country-state-city package (same as admin4.0 NewQuickBilling).
 * Re-exports Country, State, City so flow matches exactly.
 */
import { Country, State, City } from "country-state-city";

export const AllCountries = () => Country.getAllCountries();
export const getStatesOfCountry = (countryCode) =>
  State.getStatesOfCountry(countryCode || "") || [];
export const getAllStates = () => State.getAllStates();

/** Returns cities for the given country and state (ISO codes). */
export const getCitiesOfState = (countryCode, stateCode) => {
  if (!countryCode || !stateCode) return [];
  try {
    return City.getCitiesOfState(countryCode, stateCode) || [];
  } catch {
    return [];
  }
};
